import { render, staticRenderFns } from "./NewFarm.vue?vue&type=template&id=338d9ff6&lang=html&"
import script from "./NewFarm.vue?vue&type=script&lang=js&"
export * from "./NewFarm.vue?vue&type=script&lang=js&"
import style0 from "./NewFarm.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports